import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowsDiagrams = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 19,
	viewBox: "0 0 19 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_20064_16676)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M14.541 14.6728L16.041 13.1729L14.541 11.6729",
				stroke: "#323232",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.92752 7.18841L6.74252 5.55941C6.45902 5.16941 6.00527 4.93991 5.52302 4.94141L2.54102 4.95416",
				stroke: "#323232",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.541 6.43848L16.041 4.93848L14.541 3.43848",
				stroke: "#323232",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.6543 10.9385L11.8393 12.5675C12.1228 12.9575 12.5765 13.187 13.0588 13.1855L16.0408 13.1727",
				stroke: "#323232",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.041 4.95417L13.059 4.94142C12.5768 4.93917 12.123 5.16942 11.8395 5.55942L6.74252 12.5674C6.45902 12.9574 6.00527 13.1869 5.52302 13.1854L2.54102 13.1727",
				stroke: "#323232",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_20064_16676",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 18,
			height: 18,
			fill: "white",
			transform: "translate(0.291016 0.438477)"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgArrowsDiagrams);
export default ForwardRef;
